<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()">基本信息</div></van-col>
        <van-col v-if="hideCourseInfo" span="16" class="rigth" />
      </van-row>
      <div class="baseRect">
        <div class="HeadRect">
          <div class="head">
            <van-image
              width="5em"
              height="6.5em"
              fit="cover"
              radius="0.4em"
              lazy-load
              :src="data.memberList[0].student.headIcon?data.memberList[0].student.headIcon:'/img/defaultUserIcon.jpg'"
            />
          </div>
          <div class="valueRect">
            <van-row gutter="10" class="values">
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">顾客姓名: </span>{{ data.memberList[0].student.loaclName }}</van-col>
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">状态: </span><b>{{ GetEnumText('Em_LearningState',data.memberList[0].student.state) }}</b></van-col>
            </van-row>
            <van-row gutter="10" class="values breakAll">
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">姓: </span>{{ data.memberList[0].student.lastName }}</van-col>
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">名: </span>{{ data.memberList[0].student.firstName }} </van-col>
            </van-row>
            <van-row gutter="10" class="values">
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">性别: </span>{{ data.memberList[0].student.sex }}</van-col>
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">生日: </span>{{ formatDate(data.memberList[0].student.birthday,'yyyy/MM/dd') }}</van-col>
            </van-row>
            <van-row gutter="10" class="values  breakAll">
              <van-col
                v-clipboard:success="onCopySocialMediaAccount"
                v-clipboard:copy="copyStr"
                span="12"
                @click="copyStr=undefined;copyStr= data.memberList[0].student.email;"
              >
                <span :style="'color:'+GetDiveMainBack()">邮箱: </span>{{ data.memberList[0].student.email }}</van-col>
              <van-col
                v-clipboard:success="onCopySocialMediaAccount"
                v-clipboard:copy="copyStr"
                span="12"
                @click="copyStr=undefined;copyStr= data.memberList[0].student.phone;"
              >
                <span :style="'color:'+GetDiveMainBack()">电话: </span>{{ data.memberList[0].student.phoneCountry }} {{ data.memberList[0].student.phone }}</van-col>
            </van-row>
            <van-row gutter="10" class="values">
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">身高(厘米): </span>{{ data.memberList[0].student.height }}</van-col>
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">鞋码: </span>{{ data.memberList[0].student.shoeSize }}</van-col>
            </van-row>
            <van-row gutter="10" class="values">
              <van-col span="12"><span :style="'color:'+GetDiveMainBack()">体重(公斤): </span>{{ data.memberList[0].student.weight }}</van-col>
              <van-col span="12" />
            </van-row>
          </div>
        </div>
        <div class="values">  <span :style="'color:'+GetDiveMainBack()">地址: </span>
          {{ data.memberList[0].student.country }}
          {{ data.memberList[0].student.cityEng }}
          {{ data.memberList[0].student.area }}
          {{ data.memberList[0].student.address }}
          ({{ data.memberList[0].student.postalCode }})
        </div>
        <div
          v-clipboard:success="onCopySocialMediaAccount"
          v-clipboard:copy="copyStr"
          class="values"
          @click="copyStr=undefined;copyStr= data.memberList[0].student.socialMediaAccount;"
        >
          <span :style="'color:'+GetDiveMainBack()">社交媒体账号: </span>
          {{ data.memberList[0].student.socialMediaAccount }}
        </div>
        <div class="values">  <span :style="'color:'+GetDiveMainBack()">备注: </span>
          {{ data.memberList[0].student.reamrk }}
        </div>
        <div class="values">  <span :style="'color:'+GetDiveMainBack()">私密备注: </span>
          {{ data.memberList[0].student.remarkPrivate }}
        </div>
        <div
          v-clipboard:success="onCopySocialMediaAccount"
          v-clipboard:copy="copyStr"
          class="values"
          @click="copyStr=undefined;copyStr= data.memberList[0].student.bindHashCode;"
        >  <span :style="'color:'+GetDiveMainBack()">绑定信息(点击复制): </span>
          <van-tag v-if="!data.memberList[0].student.userId" type="danger" size="mini" plain hairline>未绑定用户</van-tag>
          <van-tag v-else :color="GetDiveMainBack()">已绑定用户</van-tag>&nbsp;
          <van-tag v-if="!data.memberList[0].student.headIcon || !data.memberList[0].student.address" type="danger" size="mini" plain hairline>未完善信息</van-tag>
          <van-tag v-else :color="GetDiveMainBack()">已完善信息</van-tag>
        </div>

        <van-row gutter="10" class="values">
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">潜店: </span>{{ data.diveStoreName }}</van-col>
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">课程: </span>{{ data.course.name }}</van-col>
        </van-row>
        <van-row v-if="data.team" gutter="10" class="values">
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">所在队伍: </span>{{ data.team.className }}</van-col>
          <van-col span="12"><span :style="'color:'+GetDiveMainBack()">队伍状态: </span>{{ GetEnumText('Em_ClassState',data.team.state) }}</van-col>
        </van-row>
      </div>
    </div>

    <div v-if="data" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideCourseInfo =!hideCourseInfo">行程信息</div></van-col>
        <van-col v-if="hideCourseInfo" span="16" class="rigth" @click="hideCourseInfo =!hideCourseInfo">
          {{ data.course.name }}
          <i class="iconfont icondownjt" />
        </van-col>
        <van-col v-if="!hideCourseInfo" span="16" class="rigth" @click="hideCourseInfo =!hideCourseInfo"><i class="iconfont iconupjt" /></van-col>
      </van-row>
      <div v-if="!hideCourseInfo" style="margin-top:0.5em">
        <van-steps v-if="data.team" :active="data.classStateId" :active-color="GetDiveMainBack()">
          <van-step>待开始</van-step>
          <van-step>即将开始</van-step>
          <van-step>进行中</van-step>
          <van-step>行程结束</van-step>
        </van-steps>
        <div class="baseRect">
          <div class="topTitle">{{ data.course.tripType==='Course'?'课程信息':'行程信息' }}<span :style="'color:'+GetDiveMainBack()">{{ data.course.tripType==='Course'?'COURSE':'TRAVEL' }}</span></div>
          <van-row gutter="10" class="values">
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">组织: </span>{{ GetEnumText('Em_CertificationGroupType',data.course.groupTeam) }}</van-col>
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">分类: </span>{{ data.course.typeName }}</van-col>
          </van-row>
          <van-row gutter="10" class="values">
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">课长: </span>{{ data.course.defaultDate }} day</van-col>
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">简称: </span>{{ data.course.nameShort }}</van-col>
          </van-row>
          <van-row class="values" v-if="data && data.team && data.team.dateStart">
            <van-col span="24"><span :style="'color:'+GetDiveMainBack()">行程开始: </span>{{ formatDate(data.team.dateStart,'yyyy/MM/dd') }}</van-col>
          </van-row>
          <van-row class="values">
            <van-col span="24"><span :style="'color:'+GetDiveMainBack()">备注: </span>{{ data.course.remark }}</van-col>

          </van-row>
        </div>
        <div class="baseRect">
          <div class="topTitle">{{ data.course.tripType==='Course'?'课程单元':'项目详情' }}<span :style="'color:'+GetDiveMainBack()">{{ data.course.tripType==='Course'?'UNIT':'PROJECT' }}</span></div>
          <table class="tableRect" cellspacing="0">
            <tr class="title" :style="'color:'+GetDiveMainBack()">
              <td>名称</td>
              <td>类型</td>
              <td>占比</td>
              <td>佣金</td>
            </tr>
            <tr v-for="unit in data.unitList" :key="unit.diveCourseUnitId">
              <td>{{ unit.unitName }}</td>
              <td>{{ GetEnumText('Em_CourseUnitType',unit.type) }}</td>
              <td>{{ ShowFloat(unit.proprotionMilli*0.1) }}%</td>
              <td v-if="unit.commissionCurrency">{{ unit.commissionCurrency }} {{ ShowMoney(unit.commissionTotalPrice) }}</td>
              <td v-if="!unit.commissionCurrency">N/A</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div v-if="data" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideDiveOrderInfo =!hideDiveOrderInfo">行程订单</div></van-col>
        <van-col v-if="hideDiveOrderInfo" span="16" class="rigth" @click="hideDiveOrderInfo =!hideDiveOrderInfo">
          <span v-if="!data.memberList[0].diveOrder.diveOrderId">未找到订单 </span>
          <span v-if="data.memberList[0].diveOrder.diveOrderId && data.memberList[0].diveOrder.totalPrice - data.memberList[0].diveOrder.payPrice<0.01">已结清 </span>
          <span v-if="data.memberList[0].diveOrder.diveOrderId && data.memberList[0].diveOrder.totalPrice - data.memberList[0].diveOrder.payPrice>0.01">未结清 </span>
          <i class="iconfont icondownjt" />
        </van-col>
        <van-col v-if="!hideDiveOrderInfo" span="16" class="rigth" @click="hideDiveOrderInfo =!hideDiveOrderInfo"><i class="iconfont iconupjt" /></van-col>
      </van-row>
      <div v-if="!hideDiveOrderInfo && data.memberList[0].diveOrder.diveOrderId" style="margin-top:0.5em">
        <div class="baseRect">
          <div class="topTitle">订单信息<span :style="'color:'+GetDiveMainBack()">BOOKING</span></div>
          <van-row gutter="10" class="values">
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">预订人: </span>{{ data.memberList[0].diveOrder.bookName }}</van-col>
            <van-col
              v-clipboard:success="onCopySocialMediaAccount"
              v-clipboard:copy="copyStr"
              span="12"
              @click="copyStr=undefined;copyStr= data.memberList[0].diveOrder.bookEmail;"
            >
              <span :style="'color:'+GetDiveMainBack()">邮箱: </span>{{ data.memberList[0].diveOrder.bookEmail }}</van-col>
          </van-row>
          <van-row gutter="10" class="values">
            <van-col
              v-clipboard:success="onCopySocialMediaAccount"
              v-clipboard:copy="copyStr"
              span="12"
              @click="copyStr=undefined;copyStr= data.memberList[0].diveOrder.bookPhone;"
            >
              <span :style="'color:'+GetDiveMainBack()">手机号码: </span>{{ data.memberList[0].diveOrder.bookPhone }}</van-col>
            <van-col
              v-clipboard:success="onCopySocialMediaAccount"
              v-clipboard:copy="copyStr"
              span="12"
              @click="copyStr=undefined;copyStr= data.memberList[0].diveOrder.bookSocialMediaAccount;"
            >
              <span :style="'color:'+GetDiveMainBack()">社交媒体账号: </span>{{ data.memberList[0].diveOrder.bookSocialMediaAccount }}</van-col>
          </van-row>
          <van-row gutter="10" class="values">
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">订单创建: </span>{{ formatDate(data.memberList[0].diveOrder.craeteTime,'yyyy/MM/dd hh:mm',true) }}</van-col>
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">最后修改: </span>{{ formatDate(data.memberList[0].diveOrder.lastTime,'yyyy/MM/dd hh:mm',true) }}</van-col>
          </van-row>
          <van-row gutter="10" class="values">
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">预订人: </span>{{ data.memberList[0].diveOrder.createManageName }}</van-col>
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">最后修改: </span>{{ data.memberList[0].diveOrder.lastManageName }}</van-col>
          </van-row>
          <van-row gutter="10" class="values">
            <van-col
              v-clipboard:success="onCopySocialMediaAccount"
              v-clipboard:copy="copyStr"
              span="12"
              @click="copyStr=undefined;copyStr= data.memberList[0].diveOrder.orderId;"
            >
              <span :style="'color:'+GetDiveMainBack()">商城订单号: </span>{{ data.memberList[0].diveOrder.orderId }}</van-col>
            <van-col
              v-clipboard:success="onCopySocialMediaAccount"
              v-clipboard:copy="copyStr"
              span="12"
              @click="copyStr=undefined;copyStr= data.memberList[0].diveOrder.outOrderId;"
            >
              <span :style="'color:'+GetDiveMainBack()">外部订单号: </span>{{ data.memberList[0].diveOrder.outOrderId }}</van-col>
          </van-row>
          <van-row class="values">
            <van-col span="24"><span :style="'color:'+GetDiveMainBack()">备注: </span>{{ data.memberList[0].diveOrder.remark }}</van-col>
          </van-row>
          <van-row class="values">
            <van-col span="24"><span :style="'color:'+GetDiveMainBack()">私密备注: </span>{{ data.memberList[0].diveOrder.remarkPrivate }}</van-col>
          </van-row>
        </div>
        <div class="baseRect">
          <div class="topTitle">费用<span :style="'color:'+GetDiveMainBack()">COST</span></div>
          <van-row gutter="10" class="values">
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">已付款: </span>{{ data.diveOrder?data.diveOrder.currency:'' }} <b>{{ ShowMoney(data.memberList[0].diveOrder.payPrice) }}</b></van-col>
            <van-col span="12"><span :style="'color:'+GetDiveMainBack()">总金额: </span>{{ data.diveOrder?data.diveOrder.currency:'' }} <b>{{ ShowMoney(data.memberList[0].diveOrder.totalPrice) }}</b></van-col>
          </van-row>
          <van-row class="values">
            <van-col span="24"><span :style="'color:'+GetDiveMainBack()">款项: </span>
              <van-tag v-if="0.01 > Math.abs(data.memberList[0].diveOrder.totalPrice - data.memberList[0].diveOrder.payPrice)" :color="GetDiveMainBack()">已结清</van-tag>
              <van-tag v-if="data.memberList[0].diveOrder.totalPrice < data.memberList[0].diveOrder.payPrice" :color="GetDiveMainBack()">已结清 多支付{{ data.diveOrder?data.diveOrder.currency:'' }} {{ ShowMoney(data.memberList[0].diveOrder.payPrice - data.memberList[0].diveOrder.totalPrice) }}</van-tag>
              <van-tag v-if="data.memberList[0].diveOrder.totalPrice > data.memberList[0].diveOrder.payPrice" type="warning">{{ data.diveOrder?data.diveOrder.currency:'' }} {{ ShowMoney(data.memberList[0].diveOrder.totalPrice - data.memberList[0].diveOrder.payPrice) }} 未结清</van-tag>
              <van-button
                style="min-width: 7em;margin-left:1em;"
                type="primary"
                :color="GetDiveMainBack()"
                size="mini"
                plain
                hairline
                @click="onShowDiveOrderInfo(data.memberList[0].diveOrder.diveOrderId)"
              >
                查看行程订单
              </van-button>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div v-if="data && GetIsEnableInsurance()" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideInsurance =!hideInsurance">保险</div></van-col>
        <van-col span="16" class="rigth" @click="hideInsurance = !hideInsurance">
          <span v-if="data.memberList[0].student.insuranceImage && !data.memberList[0].student.insuranceOrderId">图片保单</span>
          <span v-if="data.memberList[0].student.insuranceOrderId">电子保单</span>
          <span v-if="!data.memberList[0].student.insuranceImage && !data.memberList[0].student.insuranceOrderId">尚未提交</span>
          <i :class="hideInsurance?'iconfont icondownjt':'iconfont iconupjt'" />
        </van-col>
      </van-row>
      <div v-if="!hideInsurance" style="margin-top:0.5em">
        <div v-if="!hideInsurance" class="baseRect">
          <div v-if="data.memberList[0].insurance && data.memberList[0].insurance.order" class="insuranceOrderInfo">
            <van-row class="values">
              <van-col span="24">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">保险: </span>{{ data.memberList[0].insurance.order.productName }}</div>
              </van-col>
            </van-row>
            <van-row class="values">
              <van-col span="24">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">保障期限: </span>{{ data.memberList[0].insurance.orderInfo.deadlineText }}</div>
              </van-col>
            </van-row>
            <van-row v-if="data.memberList[0].insurance.orderInfo" class="values">
              <van-col span="12">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">保单号: </span>{{ data.memberList[0].insurance.order.insureNum }}</div>
              </van-col>
              <van-col span="12">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">保障日期: </span>{{ data.memberList[0].insurance.orderInfo.deadline }}</div>
              </van-col>
            </van-row>
            <van-row class="values">
              <van-col span="12">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">生效状态: </span>{{ GetEnumText('Em_EffectiveStatus',data.memberList[0].insurance.order.effectiveStatus) }}</div>
              </van-col>
              <van-col span="12">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">出单状态: </span>{{ GetEnumText('Em_IssueStatus',data.memberList[0].insurance.order.issueStatus) }}</div>
              </van-col>
            </van-row>
            <van-row class="values">
              <van-col span="12">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">支付状态: </span>{{ GetEnumText('Em_InsurancePayStatus',data.memberList[0].insurance.order.payStatus) }}</div>
              </van-col>
              <van-col span="12">
                <div class="breakAll"><span :style="'color:'+GetDiveMainBack()">支付时间: </span>{{ formatDate(data.memberList[0].insurance.order.createTime,'yyyy/MM/dd',true) }}</div>
              </van-col>
            </van-row>
          </div>
          <div v-if="data.memberList[0].student.insuranceImage" class="insuranceImage">
            <img :src="data.memberList[0].student.insuranceImage">
          </div>
        </div>
      </div>
    </div>
    <div v-if="data" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideManageInfo =!hideManageInfo">管理</div></van-col>
        <van-col v-if="hideManageInfo" span="16" class="rigth" @click="hideManageInfo =!hideManageInfo">
          <i class="iconfont icondownjt" />
        </van-col>
        <van-col v-if="!hideManageInfo" span="16" class="rigth" @click="hideManageInfo =!hideManageInfo">
          <i class="iconfont iconupjt" />
        </van-col>
      </van-row>
      <div v-if="!hideManageInfo" style="margin-top:0.5em">
        <div class="baseRect">
          <van-row class="values">
            <van-col span="18"><span :style="'color:'+GetDiveMainBack()">出行日期: </span>{{ formatDate(data.memberList[0].student.startTime,'yyyy/MM/dd') }}</van-col>
            <van-col span="6" class="rigth">  <van-button
              style="min-width: 8em;"
              type="primary"
              :color="GetDiveMainBack()"
              size="mini"
              plain
              hairline
              @click="onChangeStudentStartDate"
            >修改出行日期</van-button></van-col>
          </van-row>
        </div>
      </div>
    </div>
    <div v-if="data" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideProgressInfo =!hideProgressInfo">进度详情</div></van-col>
        <van-col v-if="hideProgressInfo" span="16" class="rigth" @click="hideProgressInfo =!hideProgressInfo">
          {{ GetEnumText('Em_LearningState',data.memberList[0].student.state) }}
          <i class="iconfont icondownjt" />
        </van-col>
        <van-col v-if="!hideProgressInfo" span="16" class="rigth" @click="hideProgressInfo =!hideProgressInfo"><i class="iconfont iconupjt" /></van-col>
      </van-row>
      <div v-if="!hideProgressInfo" style="margin-top:0.5em">
        <table v-for="(member,index) in data.memberList" :key="index" class="tableRect" cellspacing="0">
          <tr class="title" :style="'color:'+GetDiveMainBack()">
            <td>名称</td>
            <td>完成情况</td>
            <td>教练</td>
            <td>时间</td>
            <td>操作</td>
          </tr>
          <tr v-for="unit in data.unitList" :key="unit.diveCourseUnitId">
            <td>{{ unit.unitName }}</td>
            <template v-if="getStudentProgress(data.memberList[0].progressList,unit.diveCourseUnitId)">
              <td v-if="getStudentProgress(member.progressList,unit.diveCourseUnitId).state!=='FINISH'">
                {{ GetEnumText("Em_DiveUnitState",getStudentProgress(member.progressList,unit.diveCourseUnitId).state) }}
              </td>
              <td v-if="getStudentProgress(member.progressList,unit.diveCourseUnitId).state==='FINISH'">
                {{ GetEnumText("Em_CompletionState",getStudentProgress(member.progressList,unit.diveCourseUnitId).completionState) }}
              </td>
              <td>{{ getStudentProgress(member.progressList,unit.diveCourseUnitId).coachName }}</td>
              <td>{{ formatDate(getStudentProgress(member.progressList,unit.diveCourseUnitId).lastTime,"MM/dd hh:mm",true) }}</td>
            </template>
            <template v-else>
              <td>-</td>
              <td>-</td>
              <td>-</td>

            </template>
            <td class="center">
              <van-button
                style="min-width: 30px;"
                type="primary"
                :color="GetDiveMainBack()"
                size="mini"
                plain
                hairline
                @click="onShowProgressEdit(member,unit,getStudentProgress(member.progressList,unit.diveCourseUnitId))"
              >
                {{ member.student.state !== 'Wait' &&member.student.state !== 'OnTheoretical' &&member.student.state !== 'FinishTheoretical' &&member.student.state !== 'OnCourse'?'查看':'操作' }}
              </van-button>
            </td>
          </tr>
          <tr v-if="data.course.tripType ==='SCHEDULING'">
            <td v-if="checkAllUnitFinish(member)"><b>完成行程</b></td>
            <td v-else>完成行程</td>
            <td v-if="member.student.state ==='Certificate'||member.student.state ==='Success'">
              <b>已完成</b>
            </td>
            <td v-else>-</td>
            <td>{{ member.student.picVerifyCoachName }}</td>
            <td>-</td>
            <td class="center">
              <van-button
                style="min-width: 30px;"
                type="primary"
                :color="GetDiveMainBack()"
                size="mini"
                plain
                hairline
                :loading="buttonLoading"
                :disabled="!checkAllUnitFinish(member)"
                @click="onFinishScheduling(member)"
              >完成</van-button>
            </td>
          </tr>
          <tr v-if="data.course.tripType ==='COURSE'">
            <td v-if="checkAllUnitFinish(member)"><b>签发证书</b></td>
            <td v-else>签发证书</td>
            <td v-if="member.student.state ==='Finished'||member.student.state ==='Certificateing'">
              认证中
            </td>
            <td v-else-if="member.student.state ==='Certificate'||member.student.state ==='Success'">
              <b>认证成功</b>
            </td>
            <td v-else>-</td>
            <td>{{ member.student.picVerifyCoachName }}</td>
            <td>-</td>
            <td class="center">
              <van-button
                style="min-width: 30px;"
                type="primary"
                :color="GetDiveMainBack()"
                size="mini"
                plain
                hairline
                :disabled="!checkAllUnitFinish(member)"
                @click="onVerifyCertificate(member)"
              >提交</van-button>
            </td>
          </tr>
          <tr v-if="member.student.state==='Certificate' && !member.commentTripId">
            <td>邀请评分</td>
            <td>-</td>
            <td>-</td>
            <td>-</td>
            <td class="center">
              <van-button
                style="min-width: 30px;"
                type="primary"
                :color="GetDiveMainBack()"
                size="mini"
                plain
                hairline
                @click="onShareComment(member.student)"
              >邀请</van-button>
            </td>
          </tr>
          <tr v-if="member.commentTripId">
            <td>行程评分</td>
            <td>{{ ShowMoney(member.commentTripScore) }}分</td>
            <td>-</td>
            <td>{{ formatDate(member.commentTripDate,"MM/dd hh:mm",true) }}</td>
            <td class="center">
              <van-button
                style="min-width: 30px;"
                type="primary"
                :color="GetDiveMainBack()"
                size="mini"
                plain
                hairline
                @click="onViewComment('Course',member.commentTripId)"
              >详情</van-button>
            </td>
          </tr>
          <tr v-if="member.commentCoachId">
            <td>教练评分</td>
            <td><b>{{ ShowMoney(member.commentCoachScore) }}分</b></td>
            <td>-</td>
            <td>{{ formatDate(member.commentCoachDate,"MM/dd hh:mm",true) }}</td>
            <td class="center">
              <van-button
                style="min-width: 30px;"
                type="primary"
                :color="GetDiveMainBack()"
                size="mini"
                plain
                hairline
                @click="onViewComment('Coach',member.commentCoachId)"
              >详情</van-button></td>
          </tr>
        </table>
      </div>
    </div>
    <div v-if="data" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideEquipmentLease =!hideEquipmentLease">装备租赁</div></van-col>
        <van-col v-if="hideEquipmentLease" span="16" class="rigth" @click="hideEquipmentLease =!hideEquipmentLease">
          <i class="iconfont icondownjt" />
        </van-col>
        <van-col v-if="!hideEquipmentLease" span="16" class="rigth" @click="hideEquipmentLease =!hideEquipmentLease"><i class="iconfont iconupjt" /></van-col>
      </van-row>
      <div v-if="!hideEquipmentLease" style="margin-top:0.5em">
        <table v-for="(member,index) in data.memberList" :key="index" class="tableRect" cellspacing="0">
          <tr class="title" :style="'color:'+GetDiveMainBack()">
            <td>装备</td>
            <td>租期</td>
            <td>规格</td>
          </tr>
          <template v-if="member.equipmentLease && member.equipmentLease.length>0">
            <tr v-for="equips in member.equipmentLease" :key="equips.equipmentLeaseId">
              <td>
                <van-tag v-if="equips.isLock" :color="GetDiveMainBack()">已锁定</van-tag>
                {{ equips.equipmentLeaseId==='0'?'无需租赁':equips.title }}</td>
              <td><b>{{ equips.count }}</b> {{ equips.priceUnit }}</td>
              <td>{{ equips.specifications }}</td>
            </tr>
          </template>
        </table>
      </div>
    </div>

    <div v-if="data" class="baseRest userInfo">
      <van-row>
        <van-col span="8"><div :style="'color:'+GetDiveMainBack()" @click="hideLogInfo =!hideLogInfo">日志</div></van-col>
        <van-col v-if="hideLogInfo" span="16" class="rigth" @click="hideLogInfo =!hideLogInfo">
          <i class="iconfont icondownjt" />
        </van-col>
        <van-col v-if="!hideLogInfo" span="16" class="rigth" @click="hideLogInfo =!hideLogInfo"><i class="iconfont iconupjt" /></van-col>
      </van-row>
      <div v-if="!hideLogInfo" style="margin-top:0.5em">
        <div v-for="log in data.memberList[0].logList" :key="log.studentLogId" class="LogRect">
          <van-tag mark :color="GetDiveMainBack()">  {{ GetEnumText("Em_DiveStudentLogType",log.type ) }}</van-tag>
          <span class="data">{{ log.body }}</span>
          <span class="date">{{ formatDate(log.createTime,"yyyy/MM/dd hh:mm",true) }}</span>
        </div>
      </div>
    </div>

    <mgrVerifyCertificate v-model="showAddVerifyCertificate" @reload="init" />
    <diveCommentPopup v-model="selectCommentId" :comment-type="selectCommentType" />
    <mgrStudentStop v-model="selectStudentStopId" :title="selectStudentStopName" @reload="init" />
    <mgrStudentProgressEdit
      v-model="showStudentProgressEdit"
      :select-progress-info="selectProgressInfo"
      :student-progress-read-only="StudentProgressReadOnly"
      @reload="init()"
    />
    <mgrStudentProgressInfo v-model="showStudentProgressInfo" :select-progress-info="selectProgressInfo" />
    <mgrStudentChangeDate v-model="showStudentChangeDate" :student-id="selectStudentId" @reload="init" />
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton, Step, Steps, Tag, Image, Lazyload, Popup, Checkbox, Field, RadioGroup, Radio, Dialog, CountDown } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, GetEnumList, ShowFloat, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetIsEnableInsurance, GetDiveMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import mgrVerifyCertificate from '@/views/pro/trip/mgrVerifyCertificate'
import diveCommentPopup from '@/components/diveCommentPopup'
import mgrStudentStop from '@/views/pro/trip/mgrStudentStop'
import mgrStudentProgressEdit from '@/views/pro/trip/mgrStudentProgressEdit'
import mgrStudentProgressInfo from '@/views/pro/trip/mgrStudentProgressInfo'
import mgrStudentChangeDate from '@/views/pro/trip/mgrStudentChangeDate'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Dialog.name]: Dialog,
    [CountDown.name]: CountDown,
    TopBar,
    mgrVerifyCertificate,
    diveCommentPopup,
    mgrStudentStop,
    mgrStudentProgressEdit,
    mgrStudentProgressInfo,
    mgrStudentChangeDate,
    wxShare
  },
  data() {
    return {
      titleTop: '',
      title: '',
      buttonLoading: false,
      backurl: '/store/index',
      activeMember: 0,
      active: 0,
      studentId: undefined,
      selectStudentId: undefined,
      data: undefined,
      copyStr: undefined,
      hideCourseInfo: true,
      hideDiveOrderInfo: true,
      hideProgressInfo: false,
      hideEquipmentLease: true,
      hideManageInfo: true,
      hideInsurance: true,
      hideLogInfo: true,
      showAddVerifyCertificate: undefined,
      selectCommentId: undefined,
      selectCommentType: undefined,
      selectStudentStopId: undefined,
      selectStudentStopName: undefined,
      selectProgressInfo: undefined,
      StudentProgressReadOnly: true,
      showStudentProgressEdit: false,
      showStudentProgressInfo: false,
      showStudentChangeDate: false,
      progressForm: {
        classId: undefined,
        isClean: false,
        completionState: 'Good',
        state: 'FINISH',
        comment: '',
        studentIds: [],
        unitIds: []
      },

      system: '',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: ''
    }
  },

  created() {
    this.system = getUrlKey('system')
    this.titleTop = GetSysTitle()
    this.studentId = this.$route.params.id
    this.init(() => {
      this.title = this.data.memberList[0].student.firstName + ' ' + this.data.memberList[0].student.lastName + '顾客信息'
    })
  },
  methods: {
    GetIsEnableInsurance,
    MyNotify,
    GetEnumList,
    ShowFloat,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init(callback) {
      request({
        url: '/DiveTrip/getCoachDiveStudent',
        method: 'post',
        params: { id: this.studentId }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.data = Response.data
        this.data.memberList.forEach(item => {
          item.logList = this.data.logList.filter(m => m.studentId === item.student.studentId)
        })
        if (this.data.memberList.length > 0) {
          if (this.data.memberList[0].insurance) {
            this.data.memberList[0].insurance.orderInfo = JSON.parse(this.data.memberList[0].insurance.order.body)
            this.data.memberList[0].insurance.order.body = undefined
          }
        }
        if (callback) {
          callback()
        }
      })
    },
    getStudentProgress(list, diveCourseUnitId) {
      if (list.length <= 0) {
        return null
      }
      var select = list.filter(item => item.diveCourseUnitId === diveCourseUnitId)
      if (select.length <= 0) {
        return null
      }
      return select[0]
    },
    onChangeStudentStartDate() {
      this.selectStudentId = this.studentId
      this.showStudentChangeDate = true
    },
    checkAllUnitFinish(member) {
      return member.progressList.filter(item => item.state !== 'FINISH').length <= 0 && member.progressList.length === this.data.unitList.length
    },
    onProgressEditClose() {
      this.progressForm.state = 'FINISH'
      this.progressForm.completionState = 'Good'
      this.progressForm.comment = ''
      this.selectProgressInfo = undefined
    },
    onVerifyCertificate(member) {
      this.showAddVerifyCertificate = member
    },
    onFinishScheduling(member) {
      if (member.student.state === 'Certificate' || member.student.state === 'Success') {
        MyNotify('info', '行程已完成', 2000)
        return
      }
      this.buttonLoading = true
      request({
        url: '/DiveTrip/finishDiveScheduling',
        method: 'post',
        params: { id: member.student.studentId }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '行程已标记完成', 2000)
        this.init()
      })
    },
    onViewComment(type, commentId) {
      this.selectCommentType = type
      this.selectCommentId = commentId
    },
    onStopStudent(student) {
      this.selectStudentStopName = '终止' + student.firstName + ' ' + student.lastName + '的行程'
      this.selectStudentStopId = student.studentId
    },
    onShowProgressEdit(member, unit, progress) {
      this.StudentProgressReadOnly = member.student.state !== 'Wait' &&
         member.student.state !== 'OnTheoretical' &&
         member.student.state !== 'FinishTheoretical' &&
         member.student.state !== 'OnCourse'

      this.selectProgressInfo = {
        member: member.student,
        unit: unit,
        progress: progress
      }
      console.log('onShowProgressEdit', this.selectProgressInfo)
      if (progress) {
        this.progressForm.state = progress.state
        this.progressForm.completionState = progress.completionState
        this.progressForm.comment = progress.comment
      } else {
        this.progressForm.state = 'FINISH'
        this.progressForm.completionState = 'Good'
        this.progressForm.comment = ''
      }
      this.showStudentProgressEdit = true
    },
    onShowDiveOrderInfo(diveOrderId) {
      this.$router.push('/pro/trip/diveOrder/' + diveOrderId)
    },
    onCopySocialMediaAccount(e) {
      MyNotify('success', '已复制:' + e.text, 2000)
    },
    onShareComment(student) {
      console.log('onShareComment', student)
      this.showShare = true

      var shareBody = ''
      if (this.data.course.tripType === 'COURSE') {
        shareBody = '恭喜' + student.loaclName + '完成' + this.data.diveStoreName + ' ' + this.data.course.name + '课程,请对我的教学质量进行评分!'
      } else {
        shareBody = this.data.diveStoreName + ' ' + this.data.course.name + '行程已结束,' + student.loaclName + '请对行程及我进行评分!'
      }
      this.shareTitle = shareBody
      this.shareAbout = shareBody
      this.shareTimeline = shareBody
      this.shareUrl = undefined
      this.shareUrl = GetSelfUrl() + 'divetrip/tripComment/' + student.studentId + '?system=' + this.system
      this.shareIcon = GetSelfUrl() + 'img/picShare.jpg'
    },
    onShareFinish() {
      this.shareUrl = undefined
    }
  }
}
</script>
<style scoped>
.baseRest{
    background-color: #fff;
    margin-bottom: 0.5em;
    padding: 1em 1em;
}
.baseRest .title{
    margin-bottom: 0.5em;
}

.baseRect .values{
  font-size: 0.8em;
  padding: 0.25em 0;
}
.baseRect .topTitle{
  font-size: 0.9em;
  padding: 0.25em 0;
  font-weight: 700;
}
.baseRect .topTitle span{
  margin-left: 0.5em;
}
 .tableRect{
  width: 100%;
  font-size: 0.8em;
}
 .tableRect td{
  border:1px solid #fafafa;
  padding: 0.25em;
}

 .tableRect .title{
  text-align: center;
}

 .HeadRect{
  position: relative;
}
 .HeadRect .head{
  position: absolute;
  left: 0em;
  top: 0em;
}
 .HeadRect .valueRect{
  padding-left: 5.5em;
  min-height: 6.5em;
}

 .LogRect{
    margin-bottom: 0.25em;
    padding-bottom: 0.25em;
    border-bottom: 1px solid #f5f5f5;
}
 .LogRect:last-child{
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
}
 .LogRect .data{
    font-size: 0.8em;
    margin-left: 0.5em;
}
 .LogRect .date{
    font-size: 0.8em;
    color: #999;
    margin-left: 0.5em;
}
.insuranceImage{
  padding-top: 1em;
}
.insuranceImage img{
  width: 100%;
}
</style>
